/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S13_P1_LabelInputs */

const tr_kullanim_s13_p1_label = /** @type {(inputs: Kullanim_S13_P1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tüketici Müşteriler için (6502 sayılı Kanun Madde 52 ve Abonelik Sözleşmeleri Yönetmeliği):`)
};

const en_kullanim_s13_p1_label = /** @type {(inputs: Kullanim_S13_P1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For consumer Customers (6502 sayılı Kanun Madde 52 and Abonelik Sözleşmeleri Yönetmeliği):`)
};

const de_kullanim_s13_p1_label = /** @type {(inputs: Kullanim_S13_P1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für Verbraucherkunden (6502 sayılı Kanun Madde 52 und Abonelik Sözleşmeleri Yönetmeliği):`)
};

const ru_kullanim_s13_p1_label = /** @type {(inputs: Kullanim_S13_P1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Для клиентов-потребителей (6502 sayılı Kanun Madde 52 и Abonelik Sözleşmeleri Yönetmeliği):`)
};

/**
* | output |
* | --- |
* | "For consumer Customers (6502 sayılı Kanun Madde 52 and Abonelik Sözleşmeleri Yönetmeliği):" |
*
* @param {Kullanim_S13_P1_LabelInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s13_p1_label = /** @type {((inputs?: Kullanim_S13_P1_LabelInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S13_P1_LabelInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s13_p1_label(inputs)
	if (locale === "de") return de_kullanim_s13_p1_label(inputs)
	if (locale === "ru") return ru_kullanim_s13_p1_label(inputs)
	return tr_kullanim_s13_p1_label(inputs)
});